/**
 * Socket.io Event Types
 *
 * TypeScript interfaces for Socket.io events
 */

/**
 * Base socket event structure
 */
export interface SocketEvent<T = any> {
  type: string;
  timestamp: string;
  data: T;
}

export interface SocketTag {
  type: string;
  id?: string;
}

/**
 * Notification event payload
 */
export interface NotificationEventData {
  tags: SocketTag[];
}

/**
 * Une personne connectée (présence). Une entrée par utilisateur côté affichage.
 */
export interface PresenceEntry {
  socketId: string;
  userId: string;
  fullname: string;
  roles: string[];
  color: string;
  route: string | null;
  label: string | null;
  lastSeen: string;
}

/**
 * Curseur diffusé aux admins de la même route.
 */
export interface CursorPayload {
  userId: string;
  fullname: string;
  color: string;
  x: number;
  y: number;
}

/**
 * Socket event names
 */
export const SocketEvents = {
  // Notifications namespace
  DATA_UPDATE: "data:update",
  // Presence namespace
  LOCATION_UPDATE: "location:update",
  PRESENCE_STATE: "presence:state",
  PRESENCE_UPDATE: "presence:update",
  CURSOR_MOVE: "cursor:move",
  CURSOR_LEAVE: "cursor:leave",
} as const;

/**
 * Socket namespaces
 */
export const SocketNamespaces = {
  NOTIFICATIONS: "/notifications",
  PRESENCE: "/presence",
} as const;
